<template>
  <v-list-item draggable @dragstart="dragStart" @dragend="dndStart = false"
    :class="[dndStart ? 'blue-grey lighten-4' : '']">
    <StateIcon :call="call" />
    <v-list-item-content class="active-call-tile pb-0">
      <v-list-item-title>
        <v-icon small :color="dirIconColor">mdi-{{ dirIcon }}</v-icon>
        <span v-if="call.isBargein">
          {{ call.bargein.num | formatPhoneNum(countryCode) }}
          <v-icon>{{ bargeinIcon }}</v-icon>
          {{ call.bargein.legnum | formatPhoneNum(countryCode) }}
        </span>
        <span v-else>
          {{ call.number | formatPhoneNum(countryCode) }}
        </span>
        <v-chip v-if="call.isCallback" x-small color="orange darken-2" dark class="ml-1">{{ $t('queues.calls.callbackChip') }}</v-chip>
      </v-list-item-title>
      <v-list-item-subtitle class="active-call-name">
        <span v-if="call.isBargein">
          <v-icon>mdi-headset</v-icon>
          BARGE IN
        </span>
        <span v-else>
          {{ call.name || '--' }}
        </span>
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="isCallAXfer" class="active-call-attended-xfer pb-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small rounded color="primary" v-on="on" @click="confirmXfer">
              <v-icon small>mdi-phone-outgoing</v-icon>
              transfer
            </v-btn>
          </template>
          <span>Complete transfer {{ call.xfer.number }} to {{ call.number }}</span>
        </v-tooltip>
      </v-list-item-subtitle>
      <Menu :call="call" v-show="isOnCall" @active-call-recorder="toggleRecording" @xfer-toggle="showXfer = !showXfer"
        @active-call-dialpad="$emit('active-call-dialpad', $event)" />
    </v-list-item-content>
    <InCallActions :call="call" v-if="call.isReceiving" />
    <v-btn v-else-if="call.isSending" small color="red" icon @click="callCancel">
      <v-icon>mdi-phone-cancel</v-icon>
    </v-btn>
    <v-list-item-action v-else class="active-call-time mx-0">
      <div>
        <v-badge color="red" :value="call.recording" dot left overlap bordered dense>
          <v-icon dense>mdi-clock-outline</v-icon>
        </v-badge>
        {{ callTime | formatTime }}
      </div>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import Menu from './menu.vue'
import InCallActions from './incall_actions.vue'
import events from 'Store/events'
import StateIcon from './state_icon.vue'
import { mapActions, mapGetters } from 'vuex'
import { NotifyCallIn } from 'Store/notify'
import * as RMQClient from '@/rmqclient'

export default {
  name: 'active-calls-call',
  data () {
    return {
      showXfer: false,
      dndStart: false,
      timer: 0
    }
  },
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  beforeDestroy () {
    this.$emit('call-hangup')
  },
  components: { Menu, StateIcon, InCallActions },
  timer: 'timerUpdate',
  mounted () {
    if (this.call.isInbound) {
      const title = this.$t('sipua.notify.title')
      const contact = this.phoneNumbers.find((number) => { return number.phoneNumber.replace(/\D/g, '') === this.call.number.replace(/\D/g, '') })
      const body = this.$t('sipua.notify.body',
        { num: this.call.number, name: contact ? contact.name : this.call.name })
      const avatar = contact ? contact.imageUrl : '/default_picture_profile.png'
      const timeout = this.notifications.timeout
      NotifyCallIn(this.call.callid, title, body, avatar, timeout)
    }
  },
  computed: {
    ...mapGetters({
      countryCode: 'countryCode',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers',
      notifications: 'settings/notifications'
    }),

    callTime: function () {
      if (!this.call.answered) return 0
      const time = Math.ceil((this.timer - this.call.answered) / 1000)
      return time
    },

    dirIconColor: function () {
      return this.call.isOutgoing
        ? 'green'
        : 'primary'
    },

    dirIcon: function () {
      return this.call.isOutgoing
        ? 'call-made'
        : 'call-received'
    },

    bargeinIcon: function () {
      let icon = 'account-switch'
      switch (this.call.bargein?.mode) {
        case 'monitor':
          icon = 'microphone-off'
          break
        case 'fullbarge':
          icon = 'account-voice'
          break
        case 'whisper':
          icon = 'account-arrow-up'
          break
        default:
          break
      }
      return 'mdi-' + icon
    },

    isOnCall: function () {
      const oncall = this.call?.isOnCall
      const onhold = this.call?.isOnHold
      const muted = this.call?.isMuted
      return oncall || onhold || muted
    },

    isCallAXfer: function () {
      return !!this.call.xfer?.callid && this.call.answered
    }
  },

  methods: {
    ...mapActions({
      recToggle: 'sipua/recToggle',
      holdCall: 'sipua/holdCall',
      hangupCall: 'sipua/hangupCall',
      confirmAttendedXfer: 'sipua/confirmAttendedXfer'
    }),

    callCancel: function () {
      this.hangupCall(this.call?.callid)
    },

    timerUpdate: function () {
      this.timer = Date.now()
    },

    dragStart: function (e) {
      if (this.call.isOnCall) {
        this.dndStart = true
        e.dataTransfer.setData('call/json', JSON.stringify({
          callid: this.call.callid,
          number: this.call.number
        }))
      }
    },

    toggleRecording: function () {
      if (!this.call.monfile) {
        events.pubError(this.$t('sipua.error.recDisabled'))
        return
      }
      if (this.call.recording) {
        RMQClient.sendCmd({
          action: 'StopMixMonitor',
          channel: this.call.channel,
          srvid: this.call.amisrvid
        })
        this.dbg(`Stop recording call channel ${this.call.channel} on Asterisk server id: ${this.call.amisrvid}`)
        this.recToggle({ callid: this.call.callid, enabled: false })
        return
      }

      RMQClient.sendCmd({
        action: 'MixMonitor',
        channel: this.call.channel,
        file: this.call.monfile,
        options: 'apP',
        command: this.call.moncmd,
        srvid: this.call.amisrvid
      })
      RMQClient.sendCmd({
        action: 'Setvar',
        channel: this.call.channel,
        variable: 'CDR(monitoring)',
        value: this.call?.monCDRpath,
        srvid: this.call.amisrvid
      })
      // make sure CDR value is set too
      this.dbg(`Start recording call channel ${this.call.channel} on Asterisk server id: ${this.call.amisrvid}`)
      this.recToggle({ callid: this.call.callid, enabled: true })
    },

    confirmXfer: function () {
      // rfc5359#2.5 says : put on hold before confirm attaned x-fer
      this.holdCall({ callid: this.call.callid, enabled: true })
      this.confirmAttendedXfer({
        number: this.call.number,
        callid: this.call.xfer.callid,
        replace: this.call.callid
      })
    }
  }
}
</script>

<style scoped></style>
